import { NEW_CUSTOMER_BILLING_COMPACT_LINE } from "./newCustomerBilling";

/**
 * Phase 1 — app overview (shown while demo_tour_finished is 0).
 * Finish or ✕ calls the API and does not show this phase again.
 */
export const APP_TOUR_MAIN_STEPS = [
  {
    selector: ".org-tour-main-area",
    title: "Welcome to WOWzer",
    body: "WOWzer backs up and restores your Xero and QuickBooks Online data. This tour walks through every main area of the app so you know where to go after onboarding.",
  },
  {
    selector: ".app-tour-sidebar",
    title: "Sidebar navigation",
    body: "The sidebar is your hub. Jump between Organizations, audit history, archived files, payment methods, and settings. Collapse it with the arrow on larger screens to save space.",
  },
  {
    selector: ".org-tour-nav-settings",
    title: "Settings & profile",
    body: "Open Settings → My Profile to review your company details. Add your tax number and company address before you turn on backup subscriptions.",
  },
  {
    selector: ".org-tour-nav-payment-methods",
    title: "Payment methods",
    body: "Save a default card here. It is required before subscriptions bill after your free trial, and the same card is reused when you subscribe to organizations.",
  },
  {
    selector: ".org-tour-nav-organizations",
    title: "Organizations",
    body: "This is your main workspace: connect Xero or QuickBooks companies, manage subscriptions, run restores, and monitor backup status.",
  },
  {
    selector: ".org-tour-billing",
    title: "Billing at a glance",
    body: NEW_CUSTOMER_BILLING_COMPACT_LINE,
    optional: true,
  },
  {
    selector: ".add-org-btn",
    title: "Connect your first company",
    body: "Click Add New Organization, choose Xero or QuickBooks, and sign in to connect a company. You can add more organizations anytime.",
  },
  {
    selector: ".org-tour-filters",
    title: "Search & filters",
    body: "Find organizations quickly by name, subscription status (Trial, Subscribed), platform, and backup progress.",
  },
  {
    selector: ".org-tour-nav-audit-log",
    title: "Audit log",
    body: "See a chronological record of important actions in your account—useful for compliance and troubleshooting.",
  },
  {
    selector: ".org-tour-nav-archive",
    title: "Archived files",
    body: "Browse and download files from past backups that have been archived for long-term storage.",
  },
  {
    selector: ".app-tour-notifications",
    title: "Notifications",
    body: "The bell shows backup progress, subscription reminders, and system alerts. Mark items read or open View all for the full list.",
  },
  {
    selector: ".app-tour-profile",
    title: "Your profile menu",
    body: "Open your avatar to go to Profile or sign out. Profile is the same area as Settings → My Profile for company and billing details.",
  },
  {
    selector: ".app-tour-feedback",
    title: "Send feedback",
    body: "Share product ideas, report UI issues, or ask about archived files. Our team reads everything you submit here.",
  },
  {
    selector: ".add-org-btn",
    title: "Short follow-up after you connect",
    body: "Once a company appears in the table below, we will show one more quick tour for the row ⋮ menu and bulk subscribe. You can close any tour with ✕ or Finish—it will not appear again for that part.",
  },
];

/**
 * Phase 2 — row actions (after main tour is done and at least one org exists).
 * Dismiss is stored per user in localStorage only.
 */
export const APP_TOUR_ORG_STEPS = [
  {
    selector: ".org-three-dots",
    title: "Per-organization actions",
    body: "On each row, open the ⋮ menu to connect to Xero or QuickBooks, subscribe, restore, view backup history, or disconnect.",
  },
  {
    selector: ".org-tour-bulk-subscribe",
    title: "Bulk subscribe",
    body: "Select organizations with the checkboxes (one platform at a time), then Subscribe to enable automatic backups for several Xero or QuickBooks companies at once.",
  },
];
